import React, { useState, useEffect } from 'react'
import { Link } from 'react-scroll'

import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'

import Logo from '../assets/images/logo/neovera-banner.png'
import { ReactComponent as HomeIcon } from '../assets/images/svg/home.svg'
import { ReactComponent as ServicesIcon } from '../assets/images/svg/services.svg'
import { ReactComponent as AboutUsIcon } from '../assets/images/svg/about-us.svg'
import { ReactComponent as GalleryIcon } from '../assets/images/svg/gallery.svg'
import { ReactComponent as ContactIcon } from '../assets/images/svg/contact.svg'
import { ReactComponent as MVIcon } from '../assets/images/svg/mission-svgrepo-com.svg'

const Menu = () => {
  const [stickyClass, setStickyClass] = useState('')
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const stickNavbar = () => {
      if (window.scrollY > 50) {
        setStickyClass('sticky-nav')
      } else {
        setStickyClass('')
      }
    }
    window.addEventListener('scroll', stickNavbar)
    return () => window.removeEventListener('scroll', stickNavbar)
  }, [])

  const toggleMenu = () => setMenuOpen(!menuOpen)
  const closeMenu = () => setMenuOpen(false)

  return (
    <div className={`Menu ${stickyClass}`}>
      <div className='Menu__items'>
        <nav>
          <a href='/'>
            <img src={Logo} alt="NEOVERA SURVEYING CORPORATION banner logo" />
          </a>
          <div className='hamburger' onClick={toggleMenu}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </div>

          <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
            <li>
              <Link
                to='home'
                spy
                smooth
                offset={-90}
                duration={800}
                onClick={closeMenu}
              >
                <HomeIcon />
                Home
              </Link>
            </li>
            <li>
              <Link
                to='services'
                spy
                smooth
                offset={-100}
                duration={800}
                onClick={closeMenu}
              >
                <ServicesIcon />
                Services
              </Link>
            </li>
            <li>
              <Link
                to='aboutus'
                spy
                smooth
                offset={-150}
                duration={800}
                onClick={closeMenu}
              >
                <AboutUsIcon />
                About Us
              </Link>
            </li>
            <li>
              <Link
                to='mv'
                spy
                smooth
                offset={-150}
                duration={800}
                onClick={closeMenu}
              >
                <MVIcon />
                Mission & Vision
              </Link>
            </li>
            <li>
              <Link
                to='gallery'
                spy
                smooth
                offset={-150}
                duration={800}
                onClick={closeMenu}
              >
                <GalleryIcon />
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to='contact'
                spy
                smooth
                offset={-150}
                duration={800}
                onClick={closeMenu}
              >
                <ContactIcon />
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default Menu
